<template>
  <load-content :loading="initialLoading">
    <div class="container">
      <div class="header">
        <div id="form-search-projects" class="card">
          <Search
            v-model="searchFraze"
            :focus="searchFocus"
            @search="onSearchProjects"
            @clearSearch="onClearSearch"
          />
        </div>
        <div class="create-project" v-if="user.code_admin == true">
          <button  class="btn btn-carma" @click="openSidePanel">
            <i class="fas fa-plus"></i> Enable project
          </button>
        </div>
      </div>
      <div class="card">
        <datatable ref="table" v-if="projects" :data="tableData" :loading="filtering" :noResults="$t('datatable.empty_projects')" />
      </div>
      <div class="loading-next-page"><loader v-if="loadingNextPage" /></div>
    </div>
    <side-panel v-if="createProjectOpen" :onClose="closeSidePanel">
        <h3 class="">{{$t('project.form.enableProject.title')}}</h3>
        <ProjectEnabler @addProject="addProject" @projectAddition="setProjectAdded" />
    </side-panel>
  </load-content>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LoadContent from '@/components/load-content';
import Loader from '@/components/loader';
import Search from "@/components/Search.vue";
import Datatable from '@/components/datatable';
import CodingHeadline from '@/components/coding-headline';
import SidePanel from '@/components/side-panel';
import ProjectEnabler from '@/components/coding-admin/projectEnabler/ProjectEnabler.vue'
import InputText from '@/components/form-components/input-text';
import apiCall from '@/mixins/api/apiCall'
import i18n from "@/i18n";
import searchMixin from '@/mixins/search'

export default {
  components: {
    Datatable,
    LoadContent,
    Loader,
    Search,
    SidePanel,
    // InputText,
    ProjectEnabler
  },

  mixins: [apiCall, searchMixin],

  mounted() {
    this.$emit('setHeaderPrimaryName', '');
    this.fetch();
    this.scroll();
  },

  data: function() {
    let filters = {};
    const { name } = this.$route.query;

    if (name) {
      filters.name = name;
    }

    return {
      tableData: {},
      createProjectOpen: false,
      pagination: {
        page: 1,
        perPage: 20,
        order: 'project_name',
        sort: 'asc'
      },
      filters,
      filtering: false,
      available_projects_pagination: {
        page: 1,
        perPage: 20,
        order: 'project_name',
        sort: 'asc'
      },
      projectsAdded: false
    }
  },

  computed: {
    ...mapState({
    projects: state => state.projects.projects.data,
    activeProjects: state => state.projects.active_projects.data,
    activeProjectsIsBusy: state => state.projects.active_projects.isBusy,
    isBusy: state => state.projects.projects.isBusy,
    user: state => state.user.user.data,
    }),

    userIsAdmin() {
      return this.user && this.user.role ? this.user.role.admin : false
    },

    projectOptions() {
      let projects = (this.activeProjects && this.activeProjects.data) || [];
      return projects.map(p => ({ value: p.project_id, label: p.project_name }));
    },

    projectsPanelIsBusy() {
      return this.activeProjects === null && this.activeProjectsIsBusy === true;
    },

    initialLoading() {
      return this.isBusy === true && this.pagination.page === 1 && this.filtering === false;
    },

    loadingNextPage() {
      return this.isBusy === true && this.pagination.page !== 1;
    }
  },

  watch: {
    projects: {
      handler(value) {
        const body = value.data;
        const self = this;

        this.tableData = {
          custom_components: {
            'coding-headline': CodingHeadline
          },
          body,
          resizable: true,
          columns: [
            {
              key: 'project_name',
              label: 'Project',
              orderable: true,
              render: (row) => {
                return (
                  <div class="link" ref={`row${row.project_id}`} onClick={() => this.onClickProject(row.project_id)}>{row.project_name}</div>
                  // <div class="link" {...{ ref: `row${row.project_id}` }} onClick={() => this.onClickProject(row.project_id)}>{row.project_name}</div>
                )
              }
            },
            {
              key: 'client_name',
              label: 'Client',
              orderable: true,
              render: (row) => {
                return (
                  <div class={self.userIsAdmin ? 'link' : null} onClick={(e) => self.userIsAdmin ?
                  window.location.href = `/clients/${row.client_id}/edit` : e.preventDefault }
                  >{row.client_name}</div>
                )
              }
            },
            {
              key: 'project_id',
              label: '',
              render: (row) => {
                return (
                  <div class="flex justify-end full-width">
                    <div class="btn btn-carma mr10" onClick={() => this.onClickProject(row.project_id)}>
                      View
                    </div>
                    <div class="btn btn-default" onClick={() => this.disableProject(row)}>
                      Disable
                    </div>
                  </div>
                )
              }
            }
          ],
          order: {
            column: self.pagination.order,
            direction: self.pagination.sort,
            onChange: function(column, direction) {
              self.onSortChange(column, direction);
            }
          }
        }
      }
    }
  },

  methods: {
    fetch: function() {
      let { pagination, filters } = this;
      return this.getProjects({ pagination, filters });
    },

    onClickProject: function(projectId) {
      const projectUrl = `/analysis/projects/${projectId}`;
      this.$emit('loadSelectedProject', projectId)
      this.$router.push(projectUrl);
    },

    disableProject(project) {
      let index = this.projects.data.findIndex(p => p.project_id === project.project_id) - 2; // find index of project
      if(index < 0) index = 0

      this.apiCall('/analysis/projects/unable', 'delete', {data : {project_id: project.project_id}})
      .then(() => {
        const pages = this.pagination.page; // cache all loadedPages
        this.pagination.page = 1;
        this.pagination.perPage = pages * 20; // calculate how many pages to request
        this.fetch()
        .then(() => {
          this.pagination.page = pages; // reset pagination
          this.pagination.perPage = 20;
          const scrollTopEl = this.projects.data[index] // find project one above
          if(scrollTopEl) {
            this.$nextTick(() => {
              const scrollTopElRef = this.$refs[`row${scrollTopEl.project_id}`]

              if(index) return scrollTopElRef.scrollIntoView({ behavior: "smooth", block: "start" }); // scroll to the project above
              else {
                const { top, height } = scrollTopElRef.getBoundingClientRect();
                window.scrollTo({top: top - height * 2 - 10, behavior: 'smooth'})
              }
            })
          }
        })
      })
      .catch(() => {
        this.$notify({
            group: "store_notifications",
            type: "error",
            text: i18n.t("messages.request.error")
          });
      })
    },

    scroll: function() {
      window.onscroll = () => {
        if (this.$refs.table && this.projects.pagination.currentPage < this.projects.pagination.totalPages && this.filtering === false) {
          const wHeight = window.innerHeight;
          const { top, bottom, height } = this.$refs.table.$el.getBoundingClientRect();
          const margin = 100;

          if (top * (-1) + wHeight >= height - margin && this.isBusy == false) {
            this.pagination.page += 1;
            this.fetch();
          }
        }
      }
    },

    onSortChange: function(order, sort) {
      this.pagination.page = 1;
      this.pagination.order = order;
      this.pagination.sort = sort;
      this.filtering = true;
      this.fetch().then(r => {
        this.filtering = false;
      });
    },

    closeSidePanel: function(){
      this.createProjectOpen = false;
      if(this.projectsAdded) this.fetch()
      this.projectsAdded = false
    },

    openSidePanel: function(){
      this.createProjectOpen = true;
    },

    onSearchChange: function(value){
      this.getAllProjects({pagination:this.available_projects_pagination, filters: {name:value}});
    },

    onSearchProjects: function(value) {

      if (value) { this.filters['name'] = value }
      else { delete this.filters['name'] }

      this.filtering = true;
      this.pagination.page = 1;

      this.$router.push({ query: this.filters }).catch(err => {});

      this.fetch().then(r => {
        this.filtering = false;
      });
      this.setSearchFocus()
    },

    onClearSearch: function() {
      this.onSearchProjects();
      this.setSearchFocus()
    },

    addProject(project) {
      this.fetch()
    },

    setProjectAdded() {
      this.projectsAdded = true
    },

    ...mapActions({
      getProjects: 'projects/getProjects',
      getAllProjects: 'projects/getAllProjects',
      createProject: 'projects/createProject',
    })
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/styles/base/forms";
  @import "~@/styles/components/form";

  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  @import "~@/styles/components/loader";

  .create-project {
    text-align: right;

    .btn {
      padding: 10px 14px;

      .fas {
        margin-right: 5px;
      }
    }
  }

  .btn {
    width: auto;
    font-size: 13px;
    padding: 6px 8px;
    line-height: 1.1;
    height: auto;
    border-radius: 0;

    &:hover {
      opacity: 0.8;
    }
  }

  .link {
    width: 100%;
    cursor: pointer;
    color: #ec9148;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &:hover {
      opacity: 0.8;
      color: #27A8B1;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    #form-search-projects {
      width: 350px;
    }

    #form-search-projects {
      width: 350px;

      .input-wrapper {
        flex: 1 1 auto;
        font-size: 14px;
      }
    }
  }
</style>